export default [{
  path: '/openStaffProfile/:staffUuid',
  name: 'openStaffProfile',
  meta: {
    layout: 'empty',
  },
  component: () => import('@/views/openStaffProfile/index')
}]
